import React from 'react';
import { CheckIcon } from 'lucide-react';
export function ProductOffer() {
  return <div className="bg-white p-6 border-t border-b border-gray-300" data-id="element-100">
      <div className="max-w-3xl mx-auto" data-id="element-101">
        <div className="mb-8" data-id="element-102">
          <h2 className="text-xl font-bold mb-4" data-id="element-103">
            "But I've Tried Pillows Before..."
          </h2>
          <p className="mb-4" data-id="element-104">
            Trust me, I tried 47 of them! This isn't another "ergonomic"
            gimmick. It's precision-engineered for the "Neck Reset" protocol –
            completely different from anything you've experienced.
          </p>
          <p className="mb-4" data-id="element-105">
            <span className="font-bold" data-id="element-106">"What if it doesn't work?"</span>{' '}
            60-night FREE trial. If you don't wake up pain-free, return it. We
            have less than 3% returns because it works.
          </p>
          <p className="mb-4" data-id="element-107">
            <span className="font-bold" data-id="element-108">"Another expensive pillow?"</span> After
            my $2,847 mistake, I get this concern. At $79.95 (50% off), this
            costs less than what I spent on TWO failed pillows. Most customers
            save $2,000+ yearly in chiropractic bills.
          </p>
        </div>
        {/* Testimonial Footer */}
        <div className="bg-gray-50 p-4 border-l-4 border-blue-500 mb-4" data-id="element-109">
          <div className="flex items-start gap-4" data-id="element-110">
            <img src="https://images.unsplash.com/photo-1438761681033-6461ffad8d80" alt="Sarah M." className="w-12 h-12 rounded-full object-cover" data-id="element-111" />
            <div data-id="element-112">
              <p className="italic mb-2" data-id="element-113">
                "I tried 12 pillows and spent $200 every two weeks at my
                chiropractor. This 'Neck Reset' technique ended both cycles.
                Haven't needed an adjustment in 6 months!"
              </p>
              <p className="font-semibold" data-id="element-114">- Sarah M., Denver</p>
            </div>
          </div>
        </div>
        <div className="bg-gray-50 p-4 border-l-4 border-blue-500 mb-4" data-id="element-115">
          <div className="flex items-start gap-4" data-id="element-116">
            <img src="https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d" alt="Mike R." className="w-12 h-12 rounded-full object-cover" data-id="element-117" />
            <div data-id="element-118">
              <p className="italic mb-2" data-id="element-119">
                "After my third cervical fusion failed, my surgeon said I'd need
                pain management for life. This eliminated 90% of my morning
                pain. I cancelled my next surgery."
              </p>
              <p className="font-semibold" data-id="element-120">- Mike R., Phoenix</p>
            </div>
          </div>
        </div>
        <div className="bg-gray-50 p-4 border-l-4 border-blue-500 mb-4" data-id="element-121">
          <div className="flex items-start gap-4" data-id="element-122">
            <img src="https://images.unsplash.com/photo-1573496359142-b8d87734a5a2" alt="Dr. Lisa Chen" className="w-12 h-12 rounded-full object-cover" data-id="element-123" />
            <div data-id="element-124">
              <p className="italic mb-2" data-id="element-125">
                "I was skeptical after seeing patients waste money on so many
                pillows. But this 'Neck Reset' protocol worked for my own neck
                issues. Now I recommend it to all my patients."
              </p>
              <p className="font-semibold" data-id="element-126">- Dr. Lisa Chen, PT</p>
            </div>
          </div>
        </div>
        <div className="bg-yellow-50 border border-yellow-200 p-6 rounded-lg mb-8" data-id="element-127">
          <h3 className="text-xl font-bold text-center mb-4" data-id="element-128">
            EXCLUSIVE LIMITED-TIME OFFER!
          </h3>
          <div className="flex flex-col md:flex-row gap-6 mb-6" data-id="element-129">
            <div className="md:w-1/2" data-id="element-130">
              <p className="mb-2" data-id="element-131">
                <span className="line-through" data-id="element-132">Normally $139.95</span>, now just{' '}
                <span className="font-bold text-red-600" data-id="element-133">$69.95</span>{' '}
                <span className="text-green-600 font-semibold" data-id="element-134">
                  (Save $70!)
                </span>
              </p>
              <p className="mb-2 font-bold" data-id="element-135">
                ORDER TODAY & GET OVER $80 IN FREE GIFTS!
              </p>

              <div className="mb-4" data-id="element-136">
                <ul data-id="element-137">
                  <li className="flex items-center gap-2 mb-1" data-id="element-138">
                    <CheckIcon size={16} className="text-green-600" data-id="element-139" />
                    <span data-id="element-140">
                      The Revolutionary NUUV OrthoLift "Neck Reset" System
                    </span>
                  </li>
                  <li className="flex items-center gap-2 mb-1" data-id="element-141">
                    <CheckIcon size={16} className="text-green-600" data-id="element-142" />
                    <span data-id="element-143">
                      <span className="font-bold" data-id="element-144">BONUS:</span> Luxurious,
                      Cooling Silk Pillowcase (A $49.99 Value!)
                    </span>
                  </li>
                  <li className="flex items-center gap-2 mb-1" data-id="element-145">
                    <CheckIcon size={16} className="text-green-600" data-id="element-146" />
                    <span data-id="element-147">
                      <span className="font-bold" data-id="element-148">BONUS:</span> Exclusive "Deep
                      Sleep" Guide PDF (Unlock your best rest!)
                    </span>
                  </li>
                  <li className="flex items-center gap-2 mb-1" data-id="element-149">
                    <CheckIcon size={16} className="text-green-600" data-id="element-150" />
                    <span data-id="element-151">
                      <span className="font-bold" data-id="element-152">BONUS:</span> Priority
                      Shipping (Get your Neck Reset faster!)
                    </span>
                  </li>
                  <li className="flex items-center gap-2 mb-1" data-id="element-153">
                    <CheckIcon size={16} className="text-green-600" data-id="element-154" />
                    <span data-id="element-155">Your 60-Night Sleep Happy Guarantee!</span>
                  </li>
                </ul>
              </div>
            </div>
            <div className="md:w-1/2 flex flex-col items-center justify-center" data-id="element-156">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/vUiReD5d6AKwMBPfadP6iN/NUUV_Brand_%2818%29.png" alt="NUUV OrthoLift Pillow - Revolutionary dual-zone design" className="w-full max-w-xs rounded-md mb-4" data-id="element-157" />
              <a href="https://nuuvhome.com/products/ortholift-contour-pillow?variant=51566921744691" className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 px-6 rounded-full text-lg w-full max-w-xs text-center" target="_blank" rel="noopener noreferrer" data-id="element-158">
                YES! I WANT MY NECK RESET & BETTER SLEEP!
              </a>
            </div>
          </div>
          <div className="text-center text-sm" data-id="element-159">
            <p data-id="element-160">
              P.S. This special bundle won't last. Don't miss out on your chance
              for truly restorative sleep.
            </p>
            <p className="mt-2 font-bold" data-id="element-161">
              Don't become another pillow collector like I was.
            </p>
            <p className="mt-2" data-id="element-162">
              Thousands are experiencing their first "Neck Reset" tonight. Will
              you be next?
            </p>
          </div>
        </div>
      </div>
    </div>;
}